import React from "react";
import { Card, PageHeader } from "../../../components/common";
import "./TeacherDashboard.css";

const TeacherDashboard: React.FC = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Card style={{ padding: "24px" }}>
        <PageHeader
          title="Teacher Dashboard"
          subtitle="Welcome to your Akshar Art Teacher Portal."
        />
      </Card>
    </div>
  );
};

export default TeacherDashboard;
